import Enrolment from "./components/Enrolment"
import EnrolmentOrganisation from "./components/EnrolmentOrganisation"
import EnrolmentOrganisationInterest from "./components/EnrolmentOrganisationInterest"
import EnrolmentPersonal from "./components/EnrolmentPersonal"
import EnrolmentPersonalInterest from "./components/EnrolmentPersonalInterest"
import EnrolmentView from "./components/EnrolmentView"
import EnrolmentRequestorView from "./components/EnrolmentRequestorView"
import EnrolmentCancel from "./components/EnrolmentCancel"

let module = "frontend"

export default [
  {
    path: "template/:id/course/:cid",
    component: Enrolment,
    props: true,
    meta: { module: module, permissions: ["all"] }
  },
  {
    path: "personal/course/:cid",
    component: EnrolmentPersonal,
    props: true,
    meta: { module: module, permissions: ["all"] }
  },
  {
    path: "personal/interest",
    component: EnrolmentPersonalInterest,
    props: true,
    meta: { module: module, permissions: ["all"] }
  },
  {
    path: "organisation/course/:cid",
    component: EnrolmentOrganisation,
    props: true,
    meta: { module: module, permissions: ["all"] }
  },
  {
    path: "organisation/interest",
    component: EnrolmentOrganisationInterest,
    props: true,
    meta: { module: module, permissions: ["all"] }
  },
  {
    path: "cancel/:id/token/:token",
    component: EnrolmentCancel,
    props: true,
    meta: { module: module, permissions: ["all"] }
  },
  {
    path: "view/:id/token/:token",
    component: EnrolmentView,
    props: true,
    meta: { module: module, permissions: ["all"] }
  },
  {
    path: "view/requestor/:group_id",
    component: EnrolmentRequestorView,
    props: true,
    meta: { module: module, permissions: ["all"] }
  }
]
